import { render, staticRenderFns } from "./map-markers-legend.vue?vue&type=template&id=c2d504b4&scoped=true"
import script from "./map-markers-legend.vue?vue&type=script&lang=js"
export * from "./map-markers-legend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2d504b4",
  null
  
)

export default component.exports